module.exports = __webpack_public_path__ + "static/media/114517.618ad1aa.jpg";